import React from 'react';

import MainFeedList from './main';
import MobileFeedList from './mobile';

import style from './index.module.scss';

function Feeds(props) {
  return (
    <>
      <MobileFeedList />
      <div className={`row ${style.feeds}`}>
        <aside className={`col-lg-3 ${style['col--feeds']}`}>
          <MainFeedList />
        </aside>
        <div className={`col-md-12 col-lg-7 ${style['col--main-content']}`}>
          {props.children}
        </div>
      </div>
    </>
  )
}

export default Feeds;
